import React from 'react';
import { Box, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { isImage, isPdf } from '../../services/Functions';
import pdfIcon from '../../images/pdfIcon.png';
import { ReuploadDocumentThumbnail } from '../ReuploadDocuments/reuploadDocumentUi';
import './FormDocumentUpload.scss';

export const FormDocumentUploadedPreview = ({
  file,
  thumbnail,
  altText = 'Document',
  inlineSimplePreview = false,
}) => {
  let content = null;

  if (thumbnail && (isImage(file) || isImage(thumbnail))) {
    content = (
      <ReuploadDocumentThumbnail
        src={thumbnail}
        alt={altText}
        className="form-doc-upload-thumb"
      />
    );
  } else if (isPdf(file) || isPdf(thumbnail)) {
    const previewSrc = thumbnail || '';
    content = previewSrc ? (
      <ReuploadDocumentThumbnail
        src={previewSrc}
        alt={altText}
        className="form-doc-upload-thumb"
      />
    ) : (
      <img src={pdfIcon} alt="PDF" width="80" className="form-doc-upload-pdf-icon" />
    );
  } else {
    content = <span>Other file type</span>;
  }

  if (inlineSimplePreview) {
    return content;
  }

  return (
    <span
      className="form-doc-upload-preview-hit"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      role="presentation"
    >
      {content}
    </span>
  );
};

const FormDocumentUploadSlot = ({
  file,
  thumbnail,
  onClear,
  onChange,
  inputId,
  inputName,
  buttonLabel = 'Upload',
  validationError,
  clientError,
  altText = 'Document',
  documentExtensions,
  uploadPreviewClassName = 'upload-preview',
}) => (
  <div className="upload-wrap">
    {file ? (
      <div className="form-doc-upload-preview-wrap">
        <div className="form-doc-upload-preview-simple" title="Click to view">
          <FormDocumentUploadedPreview
            file={file}
            thumbnail={thumbnail}
            altText={altText}
            inlineSimplePreview
          />
          <button
            type="button"
            className="form-doc-upload-preview__clear"
            aria-label="Remove document"
            title="Remove to reupload"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              if (typeof onClear === 'function') {
                onClear(event);
              }
            }}
          >
            <CloseIcon fontSize="inherit" />
          </button>
        </div>
      </div>
    ) : (
      <>
        <Button
          variant="outlined"
          component="label"
          startIcon={<FileUploadOutlinedIcon />}
          className="btn"
        >
          {buttonLabel}
          <input
            hidden
            accept={documentExtensions}
            id={inputId}
            name={inputName}
            type="file"
            onChange={onChange}
          />
        </Button>
        {validationError ? (
          <Box className="documentError">{validationError}</Box>
        ) : null}
        {clientError ? <Box className="documentError">{clientError}</Box> : null}
      </>
    )}
  </div>
);

export default FormDocumentUploadSlot;
